import React, { useState } from "react";
import Pictures from "../Pic";
import { Link,NavLink } from "react-router-dom";
import menuItems from "./MenuItems";
import "./Header.css";
function Header() {
  const [active, setActive] = useState(false);

  const handleClick = () => {
    setActive(!active);
  };
  return (
    <header className="header">
      <nav className="navbar">
        <h1 className="navbar-logo">
          <Link className="headerLeft" to="/">
            <img src={Pictures.logo} className="logo" alt="" />
          </Link>
        </h1>
        <div className="menu-icon" onClick={handleClick}>
          <i className={active ? "i-close i-cross" : "i-close i-barger"}></i>
        </div>
        <ul className={active ? "nav-menu active" : "nav-menu"}>
          {menuItems.map((item, index) => {
            return (
              <li key={index} onClick={handleClick} className={item.cName}>
                {/* <Link to={item.url} className={item.cName}>
                  {item.title}
                </Link> */}
                <NavLink exact activeClassName="active" to={item.url}>
                  {item.title}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </header>
  );
}

export default Header;
